import { action } from '@play-co/replicant';
import { NotificationSettings } from '../chatbot/chatbot.ruleset';
import createActions from './utils/createActions';

export default createActions({
  updateSettings: action(
    (
      state,
      args: {
        locale?: string;
        receiveMessages?: NotificationSettings;
        music?: boolean;
        sound?: boolean;
      },
    ) => {
      if ('locale' in args) {
        state.settings.locale = args.locale;
      }

      if ('receiveMessages' in args) {
        state.settings.receiveMessages = args.receiveMessages;
      }

      if ('music' in args) {
        state.settings.music = args.music;
      }

      if ('sound' in args) {
        state.settings.sound = args.sound;
      }
    },
  ),
});
